/**
 * 极坐标柱状图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const polarBarValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: ['string', 'date'], required: true },
    { field: 'y', type: 'number', required: true }
  ],
  businessRules: [
    {
      name: 'polar-bar-data-limit',
      validator: data => Array.isArray(data) && data.length <= 30,
      message: 'Polar bar chart works best with 30 or fewer data points',
      suggestion: 'Consider reducing data points or using aggregation for better readability',
      severity: 'warning'
    },
    {
      name: 'polar-bar-x-value-diversity',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        const xValues = new Set(data.map(item => String(item[encoding?.x as string] || '')));
        return xValues.size > 1;
      },
      message: 'Polar bar chart requires diverse x-field values',
      suggestion:
        'Provide multiple different categories in the x field for meaningful polar visualization',
      severity: 'warning'
    },
    {
      name: 'polar-bar-y-value-diversity',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        const yValues = new Set(data.map(item => String(item[encoding?.y as string] || '')));
        return yValues.size > 1;
      },
      message: 'Polar bar chart requires diverse y-field values',
      suggestion: 'Provide varying numerical values in the y field for better polar representation',
      severity: 'warning'
    }
  ]
};
